
import { useState } from 'react';
import { videoTutorials } from '../../../mocks/resources';

export default function VideoTutorials() {
  const [activeVideo, setActiveVideo] = useState(videoTutorials[0]);
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section id="videos" className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-amber-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/20 border border-teal-500/30 rounded-full mb-6">
              <i className="ri-video-line text-teal-400" />
              <span className="text-teal-300 text-sm font-medium">Watch & Learn</span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              Step-by-Step
              <span className="block text-teal-400">Video Tutorials</span>
            </h2>

            <p className="text-lg text-slate-300 mb-8 leading-relaxed">
              Learn at your own pace with our comprehensive video library. From getting started to advanced features, we have got you covered with clear, practical tutorials.
            </p>

            {/* Video List */}
            <div className="space-y-3 mb-8">
              {videoTutorials.slice(0, 4).map((video) => (
                <button
                  key={video.id}
                  onClick={() => {
                    setActiveVideo(video);
                    setIsPlaying(false);
                  }}
                  className={`w-full flex items-center gap-4 p-4 rounded-xl transition-all duration-300 cursor-pointer text-left ${
                    activeVideo.id === video.id
                      ? 'bg-white/10 border border-teal-500/50'
                      : 'bg-white/5 border border-transparent hover:bg-white/10'
                  }`}
                >
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    activeVideo.id === video.id ? 'bg-teal-500' : 'bg-white/10'
                  }`}>
                    <i className={`ri-play-fill ${activeVideo.id === video.id ? 'text-white' : 'text-slate-400'}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className={`font-medium truncate ${activeVideo.id === video.id ? 'text-white' : 'text-slate-300'}`}>
                      {video.title}
                    </div>
                    <div className="text-sm text-slate-500">{video.duration} • {video.views.toLocaleString()} views</div>
                  </div>
                </button>
              ))}
            </div>

            <a
              href="#all-videos"
              className="inline-flex items-center gap-3 px-8 py-4 bg-teal-500 text-white rounded-full font-semibold hover:bg-teal-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <span>Browse All 18 Videos</span>
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* Right Video Player */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/50">
              <img
                src={activeVideo.thumbnail}
                alt={activeVideo.title}
                className="w-full aspect-video object-cover"
              />
              
              {/* Play Overlay */}
              {!isPlaying && (
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <button
                    onClick={() => setIsPlaying(true)}
                    className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300 cursor-pointer"
                  >
                    <i className="ri-play-fill text-4xl text-slate-900 ml-1" />
                  </button>
                </div>
              )}

              {/* Video Info Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-1 bg-teal-500/80 text-white text-xs rounded-md font-medium">
                    {activeVideo.category}
                  </span>
                  <span className="text-white/80 text-sm">{activeVideo.duration}</span>
                </div>
                <h3 className="text-xl font-semibold text-white">{activeVideo.title}</h3>
                <p className="text-slate-300 text-sm mt-1">{activeVideo.description}</p>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-teal-500/20 rounded-full blur-2xl" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-amber-500/20 rounded-full blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
